export const ACTIONS = {
  STOP: "stop",
  START: "start",
  PAUSE: "pause",
} as const;

export const STATUSES = {
  STOPPED: "stopped",
  STARTED: "started",
  PAUSED: "paused",
} as const;
